import React, { ReactNode, createContext, useState, useContext } from 'react';
import { useEnv } from './EnvironmentContext';

type TypeContextType = {
  type: string;
  variant: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  setVariant: React.Dispatch<React.SetStateAction<string>>;
};

const TypeContext = createContext<TypeContextType | undefined>(undefined);

export const TypeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { env } = useEnv();
  const [type, setType] = useState<string>(env.DEFAULT_ACTION);
  const [variant, setVariant] = useState<string>(env.DEFAULT_VARIANT);

  return (
    <TypeContext.Provider value={{ type, variant, setType, setVariant }}>
      {children}
    </TypeContext.Provider>
  );
};

export const useType = () => {
  const context = useContext(TypeContext);
  if (!context) {
    throw new Error("useType must be used within a TypeProvider");
  }
  return context;
};

